const COOKIE_NAME = "pabloo_session";

/**
 * Returns the client ID stored in the pabloo_session cookie
 * (e.g. "dummy-store-pabloo"), or null if not present.
 *
 * app.pabloo.com sets this cookie on sign-in:
 *   document.cookie = `pabloo_session=<clientId>; Domain=.pabloo.com; Path=/; Secure; SameSite=Lax`;
 * and clears it on sign-out:
 *   document.cookie = `pabloo_session=; Domain=.pabloo.com; Path=/; Max-Age=0`;
 */
export function readSessionCookie() {
    const match = document.cookie
        .split("; ")
        .find((row) => row.startsWith(COOKIE_NAME + "="));
    return match ? decodeURIComponent(match.split("=")[1]) : null;
}

export function isSessionActive() {
    return Boolean(readSessionCookie());
}
